export default __webpack_public_path__ + "9c965aff78c1c7dc9995279a754b9dad.png";